import axios from 'axios';
import SessionService from './Session';

const instance = axios.create({
    baseURL: 'https://api.koreanmate.app',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor to include the Bearer token for authentication and language header
instance.interceptors.request.use(
    (config) => {
        // Get current session to access JWT
        const session = SessionService.getCurrentSession();

        // If session exists and has JWT, add Authorization header
        if (session && session.jwt) {
            config.headers.Authorization = `Bearer ${session.jwt}`;
        }

        // Get language from localStorage (using the key from Language Recoil atom)
        const language = localStorage.getItem('language') || 'en';

        // Map language codes to proper Accept-Language format
        const languageMap: Record<string, string> = {
            'en': 'en-US,en;q=0.9',
            'ko': 'ko-KR,ko;q=0.9,en;q=0.8',
            'id': 'id-ID,id;q=0.9,en;q=0.8'
        };

        config.headers['Accept-Language'] = languageMap[language] || languageMap['en'];

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default instance;